<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [back]="true" [backRoute]="['/', 'benefits', 'plans', benefitPlanId]" title="Edit Benefit"></app-header>

    <app-steps #appSteps [steps]="[benefitStep, coverageStep]" action="Save" (onPrimary)="onSave()">
        <app-step #benefitStep [stepForm]="benefitEditForm" step="Benefit" title="Configure Benefit">
            <app-form-benefit #benefitEditForm [benefit]="benefit"></app-form-benefit>
        </app-step>

        <app-step
            #coverageStep
            [stepForm]="benefitCoverageEditForm"
            step="Benefit Coverage"
            [title]="'Configure ' + (benefit.benefitCategory?.name || 'Benefit') + ' Coverage'"
        >
            <app-form-benefit-coverage
                #benefitCoverageEditForm
                [benefit]="benefit"
                [benefitDetails]="benefit.benefitDetails"
            ></app-form-benefit-coverage>
        </app-step>
    </app-steps>
</div>
